import React, { useEffect, useState } from 'react';
import { Grid, Button, CssBaseline } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { AppThunkDispatch, ApplicationState } from '../../stores';
import { PersonModel } from '../../models/personModel';
import { getPersonProfile, updatePersonProfile } from '../../stores/personProfile/actions';
import { usePersonProfileStyles } from './style';
import { validationSchema } from '../../components/personProfile/validation';
import { PersonProfileCp } from '../../components/personProfile/personProfileCp';
import { PersonProfileNavbar } from '../../components/personProfileNavbar/personProfileNavbar';

function PersonProfile() {
  const personStyles = usePersonProfileStyles();
  const { t } = useTranslation();

  const profile = useSelector<ApplicationState, PersonModel | undefined>(
    state => state.personProfile.profile,
  );
  const isLoading = useSelector<ApplicationState, boolean>(state => state.loader.loading);
  const dispatch = useDispatch<AppThunkDispatch>();
  const [avatar, setAvatar] = useState<File>();

  async function handleProfileUpdate(values: PersonModel) {
    const personProfileValues = { ...values };

    if (personProfileValues.preferredGivenName) {
      personProfileValues.passportGivenName = personProfileValues.preferredGivenName;
    }
    if (personProfileValues.preferredFamilyName) {
      personProfileValues.passportFamilyName = personProfileValues.preferredFamilyName;
    }
    dispatch(updatePersonProfile(personProfileValues, avatar));
  }

  useEffect(() => {
    dispatch(getPersonProfile());
  }, [dispatch]);

  return (
    <Grid container direction='row'>
      <CssBaseline />
      <PersonProfileNavbar selectedIndex={1} />
      <Formik
        initialValues={profile || new PersonModel()}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleProfileUpdate}
      >
        {formikProps => {
          const { isValid } = formikProps;
          return (
            <Form>
              <PersonProfileCp {...formikProps} setAvatar={setAvatar} />
              <Grid item xs className={personStyles.submitButtonGrid}>
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  size='large'
                  className={personStyles.button}
                  disabled={isLoading || !isValid}
                  startIcon={<SaveIcon />}
                >
                  {t('save')}
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Grid>
  );
}

export default PersonProfile;
